const getHumanSubscriptionInterval = (interval, intervalCount) => {
  if (interval === 'year') return 'year'
  if (interval === 'month' && intervalCount === 1) return 'month'
  if (interval === 'month' && intervalCount === 3) return 'quarter'
  return 'unknown'
}

const getHumanBillingInterval = (interval, intervalCount) => {
  if (interval === 'year') return 'annually'
  if (interval === 'month' && intervalCount === 1) return 'monthly'
  if (interval === 'month' && intervalCount === 3) return 'quarterly'
  return 'unknown'
}

export { getHumanSubscriptionInterval, getHumanBillingInterval }
